import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/Layout'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/energy',
    component: () => import('@/views/energy/index'),
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  }
]

export const asyncRouterMap = [
  {
    name: 'cloud',
    meta: {
      title: '云手机管理',
    },
    path: '/cloud',
    component: Layout,
    children: [
      {
        name: 'device',
        meta: {
          title: '云手机管理',
        },
        path: 'device',
        component: () => import('@/views/cloud/device/index'),
      },
    ]
  },
  {
    name: 'app',
    meta: {
      title: '版本管理',
    },
    path: '/app',
    component: Layout,
    children: [
      {
        path: 'lab',
        name: 'lab',
        component: () => import('@/views/app/lab/index'),
        meta: {
          title: '实验室管理',
        },
      },
      {
        name: 'config',
        meta: {
          title: '配置管理',
        },
        path: 'config',
        component: () => import('@/views/app/config/index'),
      },
    ]
  },
  {
    name: 'account',
    meta: {
      title: '银行管理',
    },
    path: '/account',
    component: Layout,
    children: [
      {
        path: 'wallet',
        name: 'wallet',
        component: () => import('@/views/account/wallet/index'),
        meta: {
          title: '钱包管理',
        },
      },
      {
        path: 'bank',
        name: 'bank',
        component: () => import('@/views/account/bank/index'),
        meta: {
          title: '银行卡管理',
        },
      },
      {
        path: 'bankOperate',
        name: 'bankOperate',
        component: () => import('@/views/account/bankOperate/index'),
        meta: {
          title: '银行卡操作',
        },
      },
      {
        path: 'bankInfo',
        name: 'bankInfo',
        component: () => import('@/views/account/bankInfo/index'),
        meta: {
          title: '银行卡信息管理',
        },
      },
      {
        path: 'smsRegex',
        name: 'smsRegex',
        component: () => import('@/views/account/smsRegex/index'),
        meta: {
          title: '短信模版管理',
        },
      },
      {
        path: 'bankCardPriorityGroup',
        name: 'bankCardPriorityGroup',
        component: () => import('@/views/account/bankCardPriorityGroup/index'),
        meta: {
          title: '级距分组管理',
        },
      },
      {
        path: 'bankNoOperate',
        name: 'bankNoOperate',
        component: () => import('@/views/account/bankNoOperate/index'),
        meta: {
          title: '待分配银行卡',
        },
      },
    ]
  },
  {
    name: 'seller',
    meta: {
      title: '商户项目管理',
    },
    path: '/seller',
    component: Layout,
    children: [
      {
        path: 'project',
        name: 'project',
        component: () => import('@/views/seller/project/index'),
        meta: {
          title: '商户项目管理',
        },
      },
      {
        path: 'ch',
        name: 'ch',
        component: () => import('@/views/seller/ch/index'),
        meta: {
          title: '一级通道管理',
        },
      },
      {
        path: 'chSecond',
        name: 'chSecond',
        component: () => import('@/views/seller/chSecond/index'),
        meta: {
          title: '二级通道管理',
        },
      },
      {
        path: 'balanceChange',
        name: 'balanceChange',
        component: () => import('@/views/seller/balanceChange/index'),
        meta: {
          title: '帐变明细',
        },
      },
    ]
  },
  {
    name: 'profile',
    meta: {
      title: '个人信息管理',
    },
    path: '/profile',
    component: Layout,
    children: [
      {
        path: 'my',
        name: 'my',
        component: () => import('@/views/profile/my/index'),
        meta: {
          title: '个人信息',
        },
      },
      {
        path: 'commissionChange',
        name: 'commissionChange',
        component: () => import('@/views/profile/commissionChange/index'),
        meta: {
          title: '佣金帐变明细',
        },
      },
      {
        path: 'jifenChange',
        name: 'jifenChange',
        component: () => import('@/views/profile/jifenChange/index'),
        meta: {
          title: '积分帐变明细',
        },
      },
    ]
  },
  {
    name: 'permission',
    meta: {
      title: '权限管理',
    },
    path: '/permission',
    component: Layout,
    children: [
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/permission/role/index'),
        meta: {
          title: '后台角色管理',
        },
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/permission/menu/index'),
        meta: {
          title: '菜单管理',
        },
      },
    ]
  },
  {
    name: 'withdraw',
    meta: {
      title: '提现管理',
    },
    path: '/withdraw',
    component: Layout,
    children: [
      {
        path: 'withdrawCard',
        name: 'withdrawCard',
        component: () => import('@/views/withdraw/withdrawCard/index'),
        meta: {
          title: '提现卡列表',
        },
      },
      {
        path: 'withdrawRecord',
        name: 'withdrawRecord',
        component: () => import('@/views/withdraw/withdrawRecord/index'),
        meta: {
          title: '提现记录管理',
        },
      },
    ]
  },
  {
    name: 'user',
    meta: {
      title: '用户管理',
    },
    path: '/user',
    component: Layout,
    children: [
      {
        path: 'all',
        name: 'all',
        component: () => import('@/views/user/all/index'),
        meta: {
          title: '全部',
        },
      },
      {
        path: 'userSeller',
        name: 'userSeller',
        component: () => import('@/views/user/userSeller/index'),
        meta: {
          title: '商户',
        },
      },
      {
        path: 'userAdmin',
        name: 'userAdmin',
        component: () => import('@/views/user/userAdmin/index'),
        meta: {
          title: '管理员',
        },
      },
      {
        path: 'userSwitchboard',
        name: 'userSwitchboard',
        component: () => import('@/views/user/userSwitchboard/index'),
        meta: {
          title: '总机',
        },
      },
      {
        path: 'userWalletAdmin',
        name: 'userWalletAdmin',
        component: () => import('@/views/user/userWalletAdmin/index'),
        meta: {
          title: '钱包管理员',
        },
      },
      {
        path: 'userWalletProvider',
        name: 'userWalletProvider',
        component: () => import('@/views/user/userWalletProvider/index'),
        meta: {
          title: '钱包提供者',
        },
      },
    ]
  },
  {
    name: 'finance',
    meta: {
      title: '提现管理',
    },
    path: '/finance',
    component: Layout,
    children: [
      {
        path: 'customerBankCard',
        name: 'customerBankCard',
        component: () => import('@/views/finance/customerBankCard/index'),
        meta: {
          title: '客服银行卡筛选',
        },
      },
      {
        path: 'topupRecord',
        name: 'topupRecord',
        component: () => import('@/views/finance/topupRecord/index'),
        meta: {
          title: '充值记录管理',
        },
      },
      {
        path: 'financeCard',
        name: 'financeCard',
        component: () => import('@/views/finance/financeCard/index'),
        meta: {
          title: '财务卡管理',
        },
      },
    ]
  },
  {
    name: 'order',
    meta: {
      title: '订单管理',
    },
    path: '/order',
    component: Layout,
    children: [
      {
        path: 'orderPay',
        name: 'orderPay',
        component: () => import('@/views/order/orderPay/index'),
        meta: {
          title: '收款订单管理',
        },
      },
      {
        path: 'orderWithdraw',
        name: 'orderWithdraw',
        component: () => import('@/views/order/orderWithdraw/index'),
        meta: {
          title: '付款订单管理',
        },
      },
    ]
  },
  {
    name: 'commission',
    meta: {
      title: '佣金管理',
    },
    path: '/commission',
    component: Layout,
    children: [
      {
        path: 'commissionPay',
        name: 'commissionPay',
        component: () => import('@/views/commission/commissionPay/index'),
        meta: {
          title: '收款佣金明细',
        },
      },
      {
        path: 'commissionWithdraw',
        name: 'commissionWithdraw',
        component: () => import('@/views/commission/commissionWithdraw/index'),
        meta: {
          title: '付款佣金明细',
        },
      },
    ]
  },
  {
    name: 'setting',
    meta: {
      title: '系统设置管理',
    },
    path: '/setting',
    component: Layout,
    children: [
      {
        path: 'general',
        name: 'general',
        component: () => import('@/views/setting/general/index'),
        meta: {
          title: '系统设置',
        },
      },
      {
        path: 'proxyPool',
        name: 'proxyPool',
        component: () => import('@/views/setting/proxyPool/index'),
        meta: {
          title: '代理管理',
        },
      },
      {
        path: 'sysLog',
        name: 'sysLog',
        component: () => import('@/views/setting/sysLog/index'),
        meta: {
          title: '行为日志',
        },
      },
      {
        path: 'transferRecord',
        name: 'transferRecord',
        component: () => import('@/views/setting/transferRecord/index'),
        meta: {
          title: '转账记录',
        },
      },
      {
        path: 'jifenBalanceSnapshot',
        name: 'jifenBalanceSnapshot',
        component: () => import('@/views/setting/jifenBalanceSnapshot/index'),
        meta: {
          title: '余额历程',
        },
      },
    ]
  },
  {
    name: 'certificate',
    meta: {
      title: '凭证管理',
    },
    path: '/certificate',
    component: Layout,
    children: [
      {
        path: 'certificatePay',
        name: 'certificatePay',
        component: () => import('@/views/certificate/certificatePay/index'),
        meta: {
          title: '支付订单凭证列表',
        },
      },
      {
        path: 'certificateWithdraw',
        name: 'certificateWithdraw',
        component: () => import('@/views/certificate/certificateWithdraw/index'),
        meta: {
          title: '提现订单凭证列表',
        },
      },
    ]
  },
  {
    name: 'statistics',
    meta: {
      title: '数据统计',
    },
    path: '/statistics',
    component: Layout,
    children: [
      {
        path: 'statisticsAgent',
        name: 'statisticsAgent',
        component: () => import('@/views/statistics/statisticsAgent/index'),
        meta: {
          title: '代理数据',
        },
      },
      {
        path: 'statisticsCustomer',
        name: 'statisticsCustomer',
        component: () => import('@/views/statistics/statisticsCustomer/index'),
        meta: {
          title: '客服数据',
        },
      },
      {
        path: 'statisticsSeller',
        name: 'statisticsSeller',
        component: () => import('@/views/statistics/statisticsSeller/index'),
        meta: {
          title: '商户跑量',
        },
      },
      {
        path: 'statisticsOperator',
        name: 'statisticsOperator',
        component: () => import('@/views/statistics/statisticsOperator/index'),
        meta: {
          title: '操作员数据',
        },
      },
      {
        path: 'statisticsBankCard',
        name: 'statisticsBankCard',
        component: () => import('@/views/statistics/statisticsBankCard/index'),
        meta: {
          title: '银行卡统计',
        },
      },
      {
        path: 'statisticsManual',
        name: 'statisticsManual',
        component: () => import('@/views/statistics/statisticsManual/index'),
        meta: {
          title: '人工跑量统计',
        },
      },
    ]
  },
  {
    name: 'currency',
    meta: {
      title: '货币管理',
    },
    path: '/currency',
    component: Layout,
    children: [
      {
        path: 'fiatCurrency',
        name: 'fiatCurrency',
        component: () => import('@/views/currency/fiatCurrency/index'),
        meta: {
          title: '法币管理',
        },
      },
      {
        path: 'cryptoCurrency',
        name: 'cryptoCurrency',
        component: () => import('@/views/currency/cryptoCurrency/index'),
        meta: {
          title: '虚拟币管理',
        },
      },
      {
        path: 'cryptoCurrencyExchangeRateResource',
        name: 'cryptoCurrencyExchangeRateResource',
        component: () => import('@/views/currency/cryptoCurrencyExchangeRateResource/index'),
        meta: {
          title: '虚拟币汇率资源',
        },
      },
      {
        path: 'currencyExchangeRate',
        name: 'currencyExchangeRate',
        component: () => import('@/views/currency/currencyExchangeRate/index'),
        meta: {
          title: '货币汇率',
        },
      },
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js